<template>
    <PopupMain>
        <template #title>Edit the hem length</template>

        <form id="popup-form" @submit.prevent="sizeChange">
            Change to:
            <input ref="input" v-model="size"/>
        </form>

        <template #footer>
            <button type="submit" form="popup-form">Apply</button>
        </template>
    </PopupMain>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import PopupMain from "./PopupMain";

    export default {
        name: "HemPopup",

        components: {
            PopupMain,
        },

        data() {
            return {
                size: 0,
            }
        },

        computed: {
            ...mapState('editPopup', [
                'currentPopup',
            ]),

            ...mapGetters('editor', [
                'getPointById',
            ]),

            hem() {
                return this.hemPoint?.hem;
            },

            hemPoint() {
                const hemId = this.currentPopup.hemId;

                return this.getPointById(hemId);
            },

        },

        methods: {
            ...mapActions('editor', [
                'setHemSize',
            ]),

            ...mapActions('editPopup', [
                'clearCurrentPopup',
            ]),

            closePopup() {
                this.clearCurrentPopup();
            },

            sizeChange() {
                // to apply a new size to the hem
                this.setHemSize({ point: this.hemPoint, size: +this.size });

                this.closePopup();
            },

        },

        beforeMount() {
            // to work correctly with the input in the popup,
            // we need to create an internal variable and initialize its value
            this.size = this.hem?.size;
        },

        mounted() {
            // input field auto-focus
            this.$refs.input?.focus();
        }

    }
</script>

<style scoped>
    input {
        width: 50px;
    }
</style>